module.exports = __webpack_public_path__ + "1756014811df3bb94339e23e07d7eb01.png";